import React from 'react';
import cx from 'classnames';
import { connect } from 'react-redux';
import T from 'prop-types';
import * as actions from 'actions';
import YouTube from 'react-youtube';
import { getYTId } from 'helpers';
import * as selectors from 'selectors';
import * as Modules from 'components/modules';
import CloseIcon from 'sources/closeIcon';
import styles from './textMediaSection.css';
import * as s from './styled';

const youTubeOptions = {
  height: '390',
  width: '640',
  playerVars: {
    autoplay: 0,
    modestBranding: 1,
    controls: 1,
    fs: 0,
    rel: 0,
    showinfo: 0,
  },
};

class TextMediaSection extends React.Component {
  constructor(props) {
    super(props);

    if (props.video) {
      this.embedSrc = getYTId(props.video.src);
    }
  }

  state = { active: false, intoView: false, player: null };

  componentDidMount() {
    if (this.props.img && this.props.img.transparent === '1') {
      window.seeThru
        .create(`#${this.props.img.src.replace(/\W/g, '')}`, {
          start: 'clicktoplay',
        })
        .ready((instance) => {
          instance.play();
        });
    }
  }

  componentWillReceiveProps(nextProps) {
    const prevIntoView = this.props.scrollPosition === this.props.scrollIndex;
    const nextIntoView = nextProps.scrollPosition === this.props.scrollIndex;
    if (prevIntoView === nextIntoView) {
      return;
    }

    if (nextIntoView) {
      this.setState({ intoView: true });
    } else {
      this.setState(() => ({ intoView: false }));
    }
  }

  shouldComponentUpdate(nextProps) {
    const { scrollPosition } = nextProps;
    const { scrollIndex } = this.props;
    if (
      scrollPosition !== scrollIndex - 1 &&
      scrollPosition !== scrollIndex &&
      scrollPosition !== scrollIndex + 1
    ) {
      return false;
    }
    return true;
  }

  localVideoPauseHandler = () => {
    if (this.state.active) {
      this.setState(() => ({ active: false }));
    }
  };

  playVideo = () => {
    this.setState(
      () => ({ active: true }),
      () => {
        this.embedSrc
          ? this.state.player.playVideo()
          : this.videoElement.play();
      },
    );
  };
  pauseVideo = () => {
    this.setState(
      () => ({ active: false }),
      () => {
        this.embedSrc
          ? this.state.player.pauseVideo()
          : this.videoElement.pause();
      },
    );
  };
  spaceHandler = (e) => {
    e.preventDefault();
    if (this.state.active) {
      this.pauseVideo();
    } else {
      this.playVideo();
    }
  };

  onYTReady = (e) => {
    this.setState(
      () => ({
        player: e.target,
      }),
      () => {
        if (this.state.active) {
          e.target.playVideo();
        }
      },
    );
  };

  YTWrapperClickHandler = () => {
    const { active } = this.state;
    if (active) {
      this.pauseVideo();
    } else {
      this.playVideo();
    }
  };

  render() {
    const {
      colors,
      img,
      reversed,
      video,
      height,
      title,
      subtitle,
      description,
      textAlign,
      textHorizAlign,
    } = this.props;

    const { active, intoView } = this.state;
    const reversedNumber = +reversed;
    return (
      <s.Section
        height={height}
        backgroundColor={colors.background}
        reversed={reversedNumber}
      >
        {img &&
          img.transparent === '1' && (
            <s.ImgWrapper>
              <div className={styles.videoWrapper}>
                <video
                  className={cx(styles.video)}
                  playsInline
                  autoPlay
                  crossOrigin="anonymous"
                  loop
                  muted
                  preload
                  as="video/*"
                  id={img.src.replace(/\W/g, '')}
                >
                  <source src={img.src} type="video/mp4" />
                </video>
              </div>
            </s.ImgWrapper>
          )}

        {img &&
          img.transparent !== '1' && (
            <s.ImgWrapper>
              <s.Img src={img.src} alt={img.alt} />
            </s.ImgWrapper>
          )}
        {video && (
          <s.VideoWrapper
            className={active ? styles.videoActive : undefined}
            active={active}
          >
            <Modules.SectionKeyHandlers
              enterHandler={this.playVideo}
              spaceHandler={this.spaceHandler}
              escHandler={this.pauseVideo}
              active={intoView}
              controls
              crossOrigin
            />
            {this.embedSrc ? (
              <React.Fragment>
                <YouTube
                  onReady={this.onYTReady}
                  className={styles.ytVideo}
                  videoId={this.embedSrc}
                  opts={youTubeOptions}
                />
                {active && (
                  <button
                    className={styles.pauseYTButton}
                    onClick={this.YTWrapperClickHandler}
                  />
                )}
              </React.Fragment>
            ) : (
              /* great-todo: remove static video src and put `${video.src}` instead */
              <video
                ref={videoElement => (this.videoElement = videoElement)}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                }}
                onPause={this.localVideoPauseHandler}
                controls={active}
                poster={video.poster}
                className={active ? styles.videoActive : undefined}
                //  src="/videos/aukcyon.mp4"
                src={`${video.src}`}
                autoPlay={false}
              />
            )}
            <s.PlayButton
              onClick={this.playVideo}
              hidden={active}
              title="Воспроизвести видео"
            />
          </s.VideoWrapper>
        )}

        <s.TextWrapper
          textAlign={textAlign}
          textHorizAlign={textHorizAlign}
          hidden={active}
        >
          <s.TextContainer reversed={reversedNumber}>
            <Modules.TextBlock1
              title={title}
              subtitle={subtitle}
              description={description}
              colors={colors}
            />
          </s.TextContainer>
        </s.TextWrapper>
      </s.Section>
    );
  }
}

TextMediaSection.defaultProps = {
  height: null,
  video: null,
  img: null,
  scrollPosition: null,
  title: null,
  subtitle: null,
  description: null,
  textAlign: undefined,
  textHorizAlign: undefined,
};
TextMediaSection.propTypes = {
  title: T.string,
  subtitle: T.string,
  description: T.arrayOf(T.string),

  colors: T.shape({
    background: T.string,
    title: T.string,
    subtitle: T.string,
    description: T.string,
  }).isRequired,
  img: T.shape({ src: T.string, alt: T.string }),
  reversed: T.oneOfType([T.string, T.number]).isRequired,
  video: T.shape({
    src: T.string,
    poster: T.string,
  }),
  height: T.string,
  scrollPosition: T.number,
  scrollIndex: T.number.isRequired,
  textAlign: T.string,
  textHorizAlign: T.string,
};

const mapStateToProps = state => ({
  scrollPosition: selectors.getScrollPosition(state),
});
export default connect(mapStateToProps)(TextMediaSection);



// WEBPACK FOOTER //
// ./src/components/modules/TextMediaSection/TextMediaSection.js